<div class="modal-wrapper d-flex flex-column position-relative">
  <div class="position-absolute dotted"></div>
  <button
    (click)="activeModal.dismiss()"
    class="close-btn btn rounded-circle position-absolute d-flex align-items-center justify-content-center"
  >
    <app-qeleo-icon
      class="close-icon"
      iconName="close-o"
      size="xl"
    ></app-qeleo-icon>
  </button>
  <div class="modal-body">
    <!-- contact-form.component.html -->
    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
      <div class="d-flex flex-column gap-3">
        <div class="form-control-wrapper d-flex flex-column">
          <label class="input-title" for="fullname">Name*</label>
          <input
            type="text"
            class="input-field body-3-lg primary-text"
            id="fullname"
            formControlName="fullname"
            placeholder="Name"
          />
          <div
            *ngIf="
              contactForm.get('fullname')?.invalid &&
              (contactForm.get('fullname')?.dirty ||
                contactForm.get('fullname')?.touched)
            "
          >
            <div
              *ngIf="contactForm.get('fullname')?.errors?.['required']"
              class="error-text body-4-sm"
            >
              Name is required.
            </div>
          </div>
        </div>

        <div class="form-control-wrapper d-flex flex-column">
          <label class="input-title" for="email">Email*</label>
          <input
            type="email"
            class="input-field body-3-lg primary-text"
            id="email"
            formControlName="email"
            placeholder="Email"
          />
          <div
            *ngIf="
              contactForm.get('email')?.invalid &&
              (contactForm.get('email')?.dirty ||
                contactForm.get('email')?.touched)
            "
          >
            <div
              *ngIf="contactForm.get('email')?.errors?.['required']"
              class="error-text body-4-sm"
            >
              Email is required.
            </div>
            <div
              *ngIf="contactForm.get('email')?.errors?.['email']"
              class="error-text body-4-sm"
            >
              Email is not valid.
            </div>
          </div>
        </div>

        <div class="form-control-wrapper d-flex flex-column">
          <label class="input-title" for="organization">Organization</label>
          <input
            type="text"
            class="input-field body-3-lg primary-text"
            id="organization"
            formControlName="field[1]"
            placeholder="Organization"
          />
        </div>

        <div class="form-control-wrapper d-flex flex-column">
          <label class="input-title" for="message">Message*</label>
          <textarea
            class="input-field body-3-lg primary-text"
            id="message"
            formControlName="field[5]"
            rows="5"
            placeholder="Your message"
          ></textarea>
          <div
            *ngIf="
              contactForm.get('field[5]')?.invalid &&
              (contactForm.get('field[5]')?.dirty ||
                contactForm.get('field[5]')?.touched)
            "
          >
            <div
              *ngIf="contactForm.get('field[5]')?.errors?.['required']"
              class="error-text body-4-sm"
            >
              Message is required.
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            id="_form_11_submit"
            class="send-btn btn rounded-pill d-flex justify-content-center align-items-center w-100"
            type="submit"
            [disabled]="contactForm.invalid || submitted"
          >
            <div class="d-flex" *ngIf="!submitted">
              SEND
              <app-qeleo-icon
                iconName="arrow-right-o"
                size="xxl"
              ></app-qeleo-icon>
            </div>
            <div
              class="spinner-border text-purple"
              role="status"
              *ngIf="submitted"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
